import React, { Component } from 'react';
import Session from '../services/session'
import i from '../imports';
import c from '../components';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

const floatingLabelStyleInForm = {
    color: "#BDBDBD"
}

class ExcursionDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateValue: this.props.calcValues.dateValue,
            languageValue: this.props.calcValues.languageValue,
            toursNumberValue: this.props.calcValues.toursNumberValue,
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            dateValue: nextProps.calcValues.dateValue,
            languageValue: nextProps.calcValues.languageValue,
            toursNumberValue: nextProps.calcValues.toursNumberValue,
        });
    }


    handleDateChange = (event, value) => {
        this.setState({
            dateValue: value
        });
    }
    

    handleLanguageChange = (event, index, value) => {
        this.setState({
            languageValue: value
        });
    }

    handleToursNumberChange = (event, index, value) => {
        this.setState({
            toursNumberValue: value
        });
    }


    render() {
        let currentExcursion = new Object();
        if (this.props.currentExcursion) {
            currentExcursion = this.props.currentExcursion;
        }

        let menuItemsForSelection = i.Utils.createArrayOfNumbers(i.Utils.getMaxTouristsNumber(currentExcursion));
        //let menuItemsForSelection = i.Utils.createArrayOfNumbers(25);

        return (
            <c.FormDialog
                form_title={this.props.form_title}
                form_description={this.props.form_description}
                onClose={this.props.onClose}
                openDialog={this.props.openDialog}
                updateCalcValues={this.props.updateCalcValues}
                calcValues={this.state}
                requestType ='excursionRequest'
            >

                <i.Row>
                    {/* <i.Col xs={12} sm={6} md={6}>
                        <i.DatePicker
                            fullWidth
                            floatingLabelStyle={floatingLabelStyle}
                            underlineFocusStyle={underlineStyle}
                            underlineStyle={underlineStyle}
                            floatingLabelText={Session.model.common.words.date}
                            value={this.state.dateValue}
                            onChange={this.handleDateChange}
                        />
                    </i.Col> */}
                    <i.Col xs={12} sm={6} md={6} align='left'>
                        <i.SelectField
                            iconStyle={{ fill: "#FF5563" }}
                            className='select-field'
                            floatingLabelText={Session.model.common.words.language}
                            floatingLabelStyle={floatingLabelStyle}
                            fullWidth
                            value={this.state.languageValue}
                            onChange={this.handleLanguageChange}
                            underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                        >
                            <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={Session.model.tours.languages.choose_language} />
                            <i.MenuItem value="Eng" primaryText={Session.model.tours.languages.en} />
                            <i.MenuItem value="Ru" primaryText={Session.model.tours.languages.ru} />
                            <i.MenuItem value="Es" primaryText={Session.model.tours.languages.es} />
                        </i.SelectField>
                    </i.Col>
                </i.Row>
                <i.Row>
                    <i.Col xs={12} sm={6} md={6} align='left'>
                        <i.SelectField
                            className='select-field'
                            iconStyle={{ fill: "#FF5563" }}
                            floatingLabelText={Session.model.excursions.number_of_travellers}
                            floatingLabelStyle={floatingLabelStyle}
                            fullWidth
                            underlineFocusStyle={underlineStyle}
                            underlineStyle={underlineStyle}
                            value={this.state.toursNumberValue}
                            onChange={this.handleToursNumberChange}
                        >
                          {menuItemsForSelection.map(m => 
                                <i.MenuItem value={m} primaryText={`${m}`} /> 
                            )}
                        </i.SelectField>
                    </i.Col>
                </i.Row>
            </c.FormDialog>
        )

    }
}

export { ExcursionDialog };